/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { styles } from './themes/PlotAreaStyles.css';
import { Dimension } from '../utils/UNSAFE_visTypes/common';
import { ColorProps } from '../utils/UNSAFE_interpolations/colors';
import { styles as VisStyles } from '#hooks/PRIVATE_useVisDnd/themes/VisDndStyles.css';
import { classNames } from '#utils/UNSAFE_classNames';

type Props = {
  color?: ColorProps['color'];
  availSpace: Dimension;
  cursor?: string;
  dragOverStyle: 'accept' | 'reject' | 'none';
};

export function PlotArea({ color, availSpace, cursor, dragOverStyle }: Props) {
  const dragClass = [];
  switch (dragOverStyle) {
    case 'accept':
      dragClass.push(VisStyles.dndDragOverSvgStyle);
      break;
    case 'reject':
      dragClass.push(VisStyles.dndRejectedStyle);
      dragClass.push(styles.plotAreaStyle);
      break;
    case 'none':
      dragClass.push(styles.plotAreaStyle);
      break;
  }
  return (
    <>
      <rect
        {...availSpace}
        className={classNames(dragClass)}
        style={{ fill: dragOverStyle === 'accept' ? undefined : color, cursor }}></rect>
    </>
  );
}
